var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36973 4.85853L2.53863 9.90374C2.45849 9.98661 2.39488 10.0852 2.35147 10.1938C2.30806 10.3024 2.28571 10.419 2.28571 10.5366C2.28571 10.6543 2.30806 10.7708 2.35147 10.8794C2.39488 10.9881 2.45849 11.0866 2.53863 11.1695C2.69884 11.3355 2.91555 11.4287 3.14145 11.4287C3.36734 11.4287 3.58406 11.3355 3.74427 11.1695L8.01957 6.75717L12.2521 11.1695C12.4123 11.3355 12.629 11.4287 12.8549 11.4287C13.0808 11.4287 13.2976 11.3355 13.4578 11.1695C13.5386 11.0869 13.6028 10.9885 13.6469 10.8799C13.6909 10.7712 13.7138 10.6546 13.7143 10.5366C13.7138 10.4187 13.6909 10.302 13.6469 10.1934C13.6028 10.0847 13.5386 9.9863 13.4578 9.90374L8.62667 4.85853C8.5466 4.76805 8.44942 4.69584 8.34125 4.64645C8.23309 4.59707 8.11628 4.57157 7.9982 4.57157C7.88011 4.57157 7.7633 4.59707 7.65514 4.64645C7.54698 4.69584 7.4498 4.76805 7.36973 4.85853Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsHide);
export default __webpack_public_path__ + "static/media/iconsHide.243aeed18ee4839dc6cc20edbdd9c9d8.svg";
export { ForwardRef as ReactComponent };